import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filter", "item"]
  static values = { activeClass: { type: String, default: "wp-faqs-filter--active" } }

  filter(event) {
    event.preventDefault()
    const button = event.currentTarget
    const category = button.dataset.category || button.dataset.contentTabValue

    this.filterTargets.forEach((btn) => {
      btn.classList.toggle(this.activeClassValue, btn === button)
    })

    this.itemTargets.forEach((item) => {
      const matches = category === "all" || item.dataset.category === category
      item.hidden = !matches
      if (!matches) item.classList.remove("ex-faq-item--open")
    })
  }
}
